// TermsAcknowledgeProvider.js
// Forced-read Terms of Service + Privacy Policy acknowledgment for providers.
// Identical content to the customer version (TermsAcknowledge.js) but redirects
// to /provider/agreement after acknowledgment so providers continue their own flow.
//
// Provider onboarding flow:
//   Signup → Onboarding → /terms-acknowledge-provider → /provider/agreement
//            → /provider/handbook → /provider/dashboard
//
// Route: /terms-acknowledge-provider (ProtectedRoute role="provider")
// Providers verify email before reaching onboarding, so ProtectedRoute is safe here.

import React from 'react';
import DocumentAcknowledgment from './DocumentAcknowledgment';
import { TERMS_CONTENT } from './TermsAcknowledge';

function TermsAcknowledgeProvider() {
  return (
    <DocumentAcknowledgment
      title="Terms of Service &amp; Privacy Policy"
      content={TERMS_CONTENT}
      checkboxLabel="I have read and agree to the Evermark Memorial Terms of Service and Privacy Policy"
      firestoreField="termsAcknowledged"
      redirectPath="/provider/agreement"
    />
  );
}

export default TermsAcknowledgeProvider;
